/*
 * File: /src/store/index.js
 * Created Date: Sunday March 17th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Tuesday, 2nd April 2019 7:51:41 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
// import Vue from 'vue';
// import Vuex from 'vuex';

import actions from './modules/actions';
import appConfig from './modules/appConfig';
import auth from './modules/auth';
import agents from './modules/agents';
import brands from './modules/brands';
import callResults from './modules/callResults';
import callStatus from './modules/callStatus';
import campaigns from './modules/campaigns';
import conditions from './modules/conditions';
import connectors from './modules/connectors';
import contacts from './modules/contacts';
import contentBlocks from './modules/contentBlocks';
import customFields from './modules/customFields';
import dialDestinations from './modules/dialDestinations';
import editor from './modules/editor';
import folders from './modules/folders';
import formFieldProfiles from './modules/formFieldProfiles';
import groups from './modules/groups';
import images from './modules/images';
import interests from './modules/interests';
import leadCategory from './modules/leadCategory';
import leadStatus from './modules/leadStatus';
import leadSource from './modules/leadSource';
import leadType from './modules/leadTypes';
import lostReason from './modules/lostReasons';
import messages from './modules/messages';
import phoneNumbers from './modules/phoneNumbers';
import queues from './modules/queues';
import realtime from './modules/realtime';
import reservations from './modules/reservations';
import smsServices from './modules/smsServices';
import surveys from './modules/surveys';
import tasks from './modules/tasks';
import tags from './modules/tags';
import team from './modules/team';
import templates from './modules/templates';
import units from './modules/units';
import voice from './modules/voice';
import webhooks from './modules/webhooks';
import workflows from './modules/workflows';

// Vue.use(Vuex);


import { createStore } from 'vuex'

const debug = process.env.NODE_ENV !== 'production';

export default createStore({
  modules: {
    actions,
    appConfig,
    auth,
    agents,
    brands,
    campaigns,
    callResults,
    callStatus,
    conditions,
    connectors,
    contacts,
    contentBlocks,
    customFields,
    dialDestinations,
    editor,
    folders,
    formFieldProfiles,
    groups,
    images,
    interests,
    leadCategory,
    leadStatus,
    leadSource,
    leadType,
    lostReason,
    messages,
    phoneNumbers,
    queues,
    realtime,
    reservations,
    smsServices,
    surveys,
    tasks,
    tags,
    team,
    templates,
    units,
    voice,
    webhooks,
    workflows,
  },
  strict: debug,
  plugins: [],
});
